'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002enodes$002e$002dComment$002dNode from "./com.raquo.laminar.nodes.-Comment-Node.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_InsertContext(parentNode, sentinelNode, strictMode, extraNodeCount, extraNodesMap) {
  this.jE = null;
  this.jF = null;
  this.jG = false;
  this.iE = 0;
  this.hy = null;
  this.jE = parentNode;
  this.jF = sentinelNode;
  this.jG = strictMode;
  this.iE = extraNodeCount;
  this.hy = extraNodesMap;
}
export { $c_Lcom_raquo_laminar_inserters_InsertContext as $c_Lcom_raquo_laminar_inserters_InsertContext };
$p = $c_Lcom_raquo_laminar_inserters_InsertContext.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_inserters_InsertContext;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_InsertContext() {
}
export { $h_Lcom_raquo_laminar_inserters_InsertContext as $h_Lcom_raquo_laminar_inserters_InsertContext };
$h_Lcom_raquo_laminar_inserters_InsertContext.prototype = $p;
$p.xh = (function() {
  if ((this.jG || (this.iE !== 0))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), ("forceSetStrictMode invoked when not allowed, inside parent = " + $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_DomApi$().Tq(this.jE.cj)));
  }
  if ((this.hy === null)) {
    this.hy = new Map();
  }
  if ((!(!(!(this.jF.aV() instanceof Comment))))) {
    var contentNode = this.jF;
    var newSentinelNode = new $j_com$002eraquo$002elaminar$002enodes$002e$002dComment$002dNode.$c_Lcom_raquo_laminar_nodes_CommentNode("");
    $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_DomApi$().Vi(this.jE.cj, newSentinelNode.zc, contentNode.aV());
    this.jF = newSentinelNode;
    this.iE = 1;
    this.hy.set(contentNode.aV(), contentNode);
  }
  this.jG = true;
});
$p.WX = (function(after) {
  var elem = this.iE;
  var elem$1 = 0;
  elem$1 = elem;
  while ((elem$1 > 0)) {
    var prevChildRef = after.aV().nextSibling;
    if ((prevChildRef === null)) {
      var ev$3 = 0;
      elem$1 = ev$3;
    } else {
      var maybePrevChild = this.hy.get(prevChildRef);
      if ((maybePrevChild === (void 0))) {
        var ev$4 = 0;
        elem$1 = ev$4;
      } else if ((maybePrevChild !== (void 0))) {
        $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_nodes_ParentNode$().Cl(this.jE, maybePrevChild);
        var ev$5 = ((elem$1 - 1) | 0);
        elem$1 = ev$5;
      }
    }
  }
});
var $d_Lcom_raquo_laminar_inserters_InsertContext = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_inserters_InsertContext, "com.raquo.laminar.inserters.InsertContext", ({
  ia: 1
}));
export { $d_Lcom_raquo_laminar_inserters_InsertContext as $d_Lcom_raquo_laminar_inserters_InsertContext };
